import { Component, OnInit } from '@angular/core';
import { SafetyGeneraldashboardService } from '../services/safety-generaldashboard.service';

@Component({
  selector: 'app-homescreen-safety',
  templateUrl: './homescreen-safety.component.html',
  styleUrls: ['./homescreen-safety.component.scss']
})
export class HomescreenSafetyComponent implements OnInit {
imageUrl
image
  constructor(private _safetyGeneraldashboardService: SafetyGeneraldashboardService,) { }

  ngOnInit() {
   this.getImage();
  }
 // url(../../../Content/Images/Mainetec_BG.jpg)
  getImage(){
    this._safetyGeneraldashboardService.getHomeScreenImage().subscribe(res=>{
    
      this.imageUrl=res
      console.log("yyy",this.imageUrl)

      var t = this.imageUrl.split('url(')[1];
      console.log(t);
      var x = t.split(')');
      console.log("yyy",x);
      this.image=x[0]
  console.log(this.image)
   
      
    })
  }

//   getURL() {

//     return "this.imageUrl"
// }
}
